import { HELP_SCOPES, LANGUAGE_CODES, HELP_ARTICLE_STATUS, VALIDATION_KEYS } from "@fysaro/shared";
import { z } from "zod";

const youtubeVideoInputSchema = z
  .string()
  .optional()
  .nullable()
  .or(z.literal(""));

// Base compartida
export const baseHelpArticleSchema = z.object({
  key: z.string().min(1, VALIDATION_KEYS.GENERIC.REQUIRED),
  scope: z.enum(HELP_SCOPES).default("TENANT"),
  helpCategoryId: z.string().uuid(VALIDATION_KEYS.GENERIC.REQUIRED),
  isFeatured: z.boolean().default(false),
  order: z.number().int().min(0).default(0),
  status: z.enum(HELP_ARTICLE_STATUS).default("ACTIVE"),
  language: z.enum(LANGUAGE_CODES as [string, ...string[]]).default("es"),
  title: z.string().min(2, VALIDATION_KEYS.GENERIC.REQUIRED),
  content: z.string().min(10, VALIDATION_KEYS.GENERIC.REQUIRED),
  keywords: z.array(z.string()).default([]),
  youtubeVideoId: youtubeVideoInputSchema,
  youtubeVideoIdDark: youtubeVideoInputSchema,
});

export const createHelpArticleSchema = baseHelpArticleSchema;

export const updateHelpArticleBodySchema = baseHelpArticleSchema.partial();

export const updateHelpArticleSchema = updateHelpArticleBodySchema.extend({
  id: z.string().uuid(),
});

export const helpArticleTranslationSchema = z.object({
  id: z.string().uuid().optional().nullable(),
  helpArticleId: z.string().uuid().optional().nullable(),
  language: z.enum(LANGUAGE_CODES as [string, ...string[]]),
  title: z.string().min(2, VALIDATION_KEYS.GENERIC.REQUIRED),
  content: z.string().min(10, VALIDATION_KEYS.GENERIC.REQUIRED),
  keywords: z.array(z.string()).default([]),
  youtubeVideoId: youtubeVideoInputSchema,
  youtubeVideoIdDark: youtubeVideoInputSchema,
});
